import type { ComposerTranslation } from 'vue-i18n';
import type { ItemWithQuantity } from '~/types/halloween/items';
import type { RawStatefulLog } from '~/utils/halloween/create-raw-stateful-log';
import halloweenItemRegistry from '~/utils/halloween/halloween-item-registry';
import loadStoryConfig from '~/utils/halloween/load-story-config';

interface EventRawDetails {
  eventTranslationKeys: string[];
  uniqueEventIndex: string;
  healthChange: number;
  targetCharacterIndex: number | 'all';
  inventoryChange: ItemWithQuantity | null;
}

export default function parseExpeditionLogs(
  t: ComposerTranslation,
  currentLog: RawStatefulLog,
  previousLog: RawStatefulLog | null
) {
  const { buildReplicas } = loadStoryConfig(t);

  const eventType = parseInt(currentLog.eventVariation.slice(0, 4));

  const targetCharacterIndex = parseInt('0x' + currentLog.eventVariation.slice(-4, -2));

  const resultingRawEvent: EventRawDetails = {
    eventTranslationKeys: [],
    uniqueEventIndex: currentLog.uniqueEventIndex,
    healthChange: 0,
    targetCharacterIndex: targetCharacterIndex === previousLog?.aliveCharacters.length ? 'all' : targetCharacterIndex,
    inventoryChange: null
  };

  const currentEventToken = halloweenItemRegistry.getByAddress('0x' + currentLog.eventVariation.slice(-40));

  switch (eventType) {
    case 1:
      resultingRawEvent.eventTranslationKeys = buildReplicas(
        currentLog.location,
        'good',
        currentLog.index % 2 === 0 ? 1 : 0
      );
      resultingRawEvent.healthChange = parseInt('0x' + currentLog.eventVariation.slice(-2));
      break;
    case 2:
      resultingRawEvent.eventTranslationKeys = buildReplicas(
        currentLog.location,
        'bad',
        currentLog.index % 2 === 0 ? 0 : 1
      );
      resultingRawEvent.healthChange = parseInt('0x' + currentLog.eventVariation.slice(-2)) * -1;
      break;
    case 3:
      resultingRawEvent.eventTranslationKeys = [t(`halloweenExpeditionLogLootEvent`)];
      resultingRawEvent.inventoryChange = currentEventToken
        ? halloweenItemRegistry.withQuantity(
            currentEventToken,
            parseInt('0x' + currentLog.eventVariation.slice(-44, -40))
          )
        : null;
      break;
    case 4:
      resultingRawEvent.eventTranslationKeys = buildReplicas(
        currentLog.location,
        'story',
        parseInt('0x' + currentLog.eventVariation.slice(-2))
      );
      break;
    case 5:
      resultingRawEvent.healthChange = parseInt('0x' + currentLog.eventVariation.slice(-6, -4)) * -1;
      resultingRawEvent.eventTranslationKeys = buildReplicas(
        currentLog.location,
        'enemy',
        parseInt('0x' + currentLog.eventVariation.slice(-2))
      );
      break;
    default:
      break;
  }

  return resultingRawEvent;
}
